module.exports = __webpack_public_path__ + "19267212ead13d18cde1dc17fd75b335.svg";